import { OverridesStyleRules } from '@mui/material/styles/overrides';

import { tableCellInterpolation } from '../interpolations/table-cell.interpolation';

export const tableCellOverrides:
  | Partial<OverridesStyleRules<'head' | 'body', 'MuiTableCell'>>
  | undefined = {
  head: {
    ...(tableCellInterpolation as object),
    padding: '0',
    verticalAlign: 'middle',
    textTransform: 'uppercase',
    fontSize: '12px',
    letterSpacing: '0.1em',
  },
  body: tableCellInterpolation,
};
